import PipelineList from "./List";
import PipelineDetail from "./Detail";

export { PipelineList, PipelineDetail };
